import L from 'leaflet';

export const MapHelper = {
    createMap,
    removeMap,
}

function removeMap(map) {
    map.remove();
}

function createMap({ id, latitude, longitude, radius, showMapHandlers = false, zoom = 16 }) {
    if (latitude === undefined || latitude === null
        || longitude === undefined || longitude === null)
        return;

    const map = createMap(id , latitude, longitude);
    if (!showMapHandlers) {
        disableMapHandlers(map);
    }
    addDotToMap(map, radius);

    if (radius)
        addCircleToMap(map, radius);

    return map;

    ////
    function createMap(mapDomId, latitude, longitude) {
        return L.map(mapDomId, {
            center: [latitude, longitude],
            zoomControl: false,
            zoom: zoom,
            layers: [
                // https, not http: the app is served over TLS and the browser
                // blocks the plain-http tiles as mixed content, leaving the map
                // as an empty grey grid.
                L.tileLayer(
                    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    { attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors' }
                ),
            ],
        });
    }

    function disableMapHandlers(map) {
        map._handlers.forEach(handler => {
            handler.disable();
        });
    }

    function addDotToMap(map) {
        L.circle(
            [latitude, longitude],
            {
                color: '#009fdf',
                fillColor: '#009fdf',
                fillOpacity: 0.5,
                radius: 10,
                weight: 1,
                interactive: false,
            },
        ).addTo(map);
    }

    function addCircleToMap(map, radius) {
        L.circle(
            [latitude, longitude],
            {
                color: '#009fdf',
                fillColor: '#009fdf',
                fillOpacity: 0.5,
                radius: radius,
                weight: 1,
                interactive: false,
            },
        ).addTo(map);
    }
}